function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 45.699219 11.5 L 2.300781 11.5 C 1.199219 11.5 0.300781 10.601562 0.300781 9.5 C 0.300781 8.398438 1.199219 7.5 2.300781 7.5 L 45.699219 7.5 C 46.800781 7.5 47.699219 8.398438 47.699219 9.5 C 47.699219 10.601562 46.800781 11.5 45.699219 11.5 Z M 45.699219 11.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 45.699219 26 L 2.300781 26 C 1.199219 26 0.300781 25.101562 0.300781 24 C 0.300781 22.898438 1.199219 22 2.300781 22 L 45.699219 22 C 46.800781 22 47.699219 22.898438 47.699219 24 C 47.699219 25.101562 46.800781 26 45.699219 26 Z M 45.699219 26 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 45.699219 40.5 L 2.300781 40.5 C 1.199219 40.5 0.300781 39.601562 0.300781 38.5 C 0.300781 37.398438 1.199219 36.5 2.300781 36.5 L 45.699219 36.5 C 46.800781 36.5 47.699219 37.398438 47.699219 38.5 C 47.699219 39.601562 46.800781 40.5 45.699219 40.5 Z M 45.699219 40.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.632689955656f7ae9a4d3d80d0722bf0.svg";
export { ForwardRef as ReactComponent };